// extracted by mini-css-extract-plugin
export default {"videoContent":"videoContent--_lCyWH5jDSuQ4VX"};